const person = (touched=null) => {
    return {
        zoomIn: {
            value:true,
        },
        meta:{
            touched: touched,
            valid:null,
        },
        personid:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        personTyp:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:false,
        },
        anrede:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        anredeIndividuell:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        titel:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        titelIndividuell:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        institution:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:false,
        },
        vorname:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
            overrideRules:null,
            overrideValidator:null,
        },
        nachname:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        geburtsdatum:{
            value: null,
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        strasse:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        hausnummer:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        adresszusatz:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        plz:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            msg:'',
            display:true,
        },
        plzVorschlagsliste:{
            value: [
            ],
            touched: touched,
            valid:null,
            required:true,
            msg:'',
            display:true,

        },
        ort:{
            value: '',
            touched: touched,
            valid:null,
            required:true,
            display:true,
        },
        email:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        telefon:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:true,
        },
        personalausweisnummer:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:false,
        },
        reisepassnummer:{
            value: '',
            touched: touched,
            valid:null,
            required:false,
            display:false,
        }
    }
}
export default person;